import { render, staticRenderFns } from "./CompEventsCalendar.vue?vue&type=template&id=7f9e75af"
import script from "./CompEventsCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./CompEventsCalendar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports